module.exports = __webpack_public_path__ + "media/audio22.2986b843.mp3";